/**
 * @generated SignedSource<<866081fcf7d7262f140ca6d94be95dba>>
 * @relayHash f9ca0c6d46f517f6d908bd327972e2da
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d3e73d4b2171a44acf3020206988b6e04ee509d46422cdee27046a9cfd3e6cd6

import type { ConcreteRequest } from 'relay-runtime';
export type useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery$variables = {
  cloudId: string;
};
export type useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly id: string;
        readonly transactionAccount: {
          readonly __typename?: string;
          readonly id?: string;
          readonly isCurrentUserBillingAdmin: boolean | null;
        } | null;
      } | null;
    } | null;
  } | null> | null;
};
export type useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery = {
  response: useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery$data;
  variables: useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "hamsProductKey",
    "value": "confluence.ondemand"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "isCurrentUserBillingAdmin"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "transactionAccount",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      },
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v2/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "transactionAccount",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v3/*: any*/)
                        ],
                        "type": "Node",
                        "abstractKey": "__isNode"
                      }
                    ]
                  }
                ]
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f9ca0c6d46f517f6d908bd327972e2da",
    "id": "d3e73d4b2171a44acf3020206988b6e04ee509d46422cdee27046a9cfd3e6cd6",
    "metadata": {},
    "name": "useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery",
    "operationKind": "query",
    "text": "query useIsEligibleForUpflowV2ConfluenceStandardFGsExperimentQuery($cloudId:ID!){tenantContexts(cloudIds:[$cloudId]){entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,entitlement{__typename,id,transactionAccount{__typename,...on Node{__isNode:__typename,id,__typename},isCurrentUserBillingAdmin}}}}}"
  }
};
})();

(node as any).hash = "5ffb5864cc8b6acf0f584617c954e009";

export default node;
